import state from './moduleOcorrenciaState'
import mutations from './moduleOcorrenciaMutations'
import actions from './moduleOcorrenciaActions'
import getters from './moduleOcorrenciaGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
